// AI-CONTEXT: See docs/features/updates-log.md
// Vormcontrole op één entry uit updates.json. Twee afnemers: de test over
// updates.json (die een kapotte entry tegenhoudt vóór de commit) en
// filterUpdates (die hem overslaat als hij er tóch doorheen komt).

import formatUpdateDate from './formatUpdateDate'
import { UPDATE_MODULE_SLUGS } from './updateModules'

/** @param {*} value @returns {boolean} */
const isGevuldeTekst = (value) => typeof value === 'string' && value.trim().length > 0

/**
 * @typedef {object} Update
 * @property {string} id - Uniek, begint met de datum: 'YYYY-MM-DD-korte-slug'
 * @property {string} date - ISO-datum, 'YYYY-MM-DD'
 * @property {Array<string>} modules - Eén of meer codes uit UPDATE_MODULE_SLUGS
 * @property {string} title - Korte kop in lekentaal
 * @property {string} body - Uitleg van wat de gebruiker eraan heeft
 * @property {Array<string>} [bullets] - Optionele opsomming
 */

/**
 * @param {*} entry - Kandidaat-entry uit updates.json
 * @returns {boolean} true als de entry veilig te tonen is
 */
const isValidUpdate = (entry) => {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return false

    if (!isGevuldeTekst(entry.id)) return false
    if (!isGevuldeTekst(entry.title)) return false
    if (!isGevuldeTekst(entry.body)) return false

    // Hergebruikt de datumcontrole van de opmaakfunctie: wat niet te tonen is,
    // is ook niet geldig. Eén bron, dus ze kunnen niet uit elkaar lopen.
    if (formatUpdateDate(entry.date) === '') return false

    if (!Array.isArray(entry.modules) || entry.modules.length === 0) return false
    if (!entry.modules.every((slug) => UPDATE_MODULE_SLUGS.includes(slug))) return false

    if (entry.bullets !== undefined) {
        if (!Array.isArray(entry.bullets) || entry.bullets.length === 0) return false
        if (!entry.bullets.every(isGevuldeTekst)) return false
    }

    return true
}

export default isValidUpdate
